angular.module 'zc.projects'

.controller 'HomeCtrl', ($state, $translate, Agency, Devise, Page, projects) ->
  Page.setBodyClass ''
  $translate('projects.controllers.homeController.siteList').then (translation) ->
    Page.setTitle translation

  RECENT_PROJECT_LIMIT = 6

  vm = this


  vm.$onInit = ->
    vm.Devise = Devise
    vm.projects = _.filter projects, is_terminated: false
    vm.agencies = []
    vm.recentProjects = _.chain vm.projects
                         .sortBy (project) -> -moment(project.created_at).valueOf()
                         .take RECENT_PROJECT_LIMIT
                         .value()

    Agency.all().then (agencies) ->
      vm.agencies = agencies

    vm.goToProject = (project) ->
      $state.go 'admin.projects.campaigns.list',
        projectId: project.id

  return



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/controllers/home.controller.coffee